<script lang="ts" setup>
import { LearningItem } from '@/models/learning-item.model';
import learningItemService from '@/services/learning-item.service';
import { ref } from 'vue';

const file = ref<File | null>(null);
const result = ref<LearningItem[]>();
const loading = ref<boolean>(false);

const valid = ref<boolean>(false);

async function importItems() {
  loading.value = true;
  if (file.value) {
    const response = await learningItemService.upload(file.value);

    result.value = response.data;

    file.value = null;
  }
  loading.value = false;
}

const fileRules = [
  (value: File) => {
    if (value) return true;

    return 'File is required';
  },
  (value: File[]) => {
    if (value && value.length && value[0].type?.indexOf('csv') !== -1) {
      return true;
    }

    return 'File must be of type CSV';
  },
];
</script>
<template>
  <v-form v-model="valid" @submit.prevent="importItems">
    <v-container>
      <h2>Import learning items</h2>

      <v-row>
        <v-col cols="9">
          <v-file-input
            v-model="file"
            label="CSV"
            filter-by-type="text/csv"
            :rules="fileRules"
            :disabled="loading"
          />
        </v-col>

        <v-col>
          <v-btn
            class="mt-2"
            type="submit"
            color="success"
            block
            :disabled="loading"
            >Import</v-btn
          >
        </v-col>
      </v-row>
      <v-alert type="warning" v-if="loading">Importing...</v-alert>
      <v-alert type="info">
        <p>
          The CSV can be re-uploaded, with changes, but changes to the
          <i>Link</i> field will not be tracked and create a
          <strong>new Learning Item</strong>.
        </p>
        <p class="mt-4">The following columns will be used when uploading:</p>
        <ul class="mt-4" style="padding-left: 30px">
          <li>Title</li>
          <li>TitleNL</li>
          <li>Description</li>
          <li>DescriptionNL</li>
          <li>Recommendation</li>
          <li>RecommendationNL</li>
          <li>Type</li>
          <li>Category</li>
          <li>Author</li>
          <li>Duration</li>
          <li>Link</li>
          <li>Form</li>
        </ul>
      </v-alert>
    </v-container>
  </v-form>
</template>
